import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=970696b0&scoped=true&"
import script from "./QuestionCard.vue?vue&type=script&lang=js&"
export * from "./QuestionCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=970696b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970696b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('970696b0')) {
      api.createRecord('970696b0', component.options)
    } else {
      api.reload('970696b0', component.options)
    }
    module.hot.accept("./QuestionCard.vue?vue&type=template&id=970696b0&scoped=true&", function () {
      api.rerender('970696b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Settings/components/QuestionCard.vue"
export default component.exports